import classNames from 'classnames';

import { policyWrapper } from '../../../../styles/PolicyStyles';

const PrivacyPolicy_v5 = (): JSX.Element => {
  return (
    <article css={policyWrapper}>
      <p className="f13 c_gray">
        (주)중고나라(이하 &quot;회사&quot;라 함)은 회사가 운영하는 인터넷 사이트
        및 모바일 애플리케이션(이하 “중고나라” 함)을 이용하는 회원들의
        개인정보를 매우 중요하게 생각하며, 통신비밀보호법, 전기통신사업법,
        정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법 등
        정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을
        준수하고, 이를 중고나라 약관에 공개하여 고객(이하 “회원”이라 함)이
        언제나 용이하게 열람할 수 있도록 하고 있습니다. 회사는 정부의 법률 및
        지침 변경 등에 따라 수시로 개인정보처리방침을 바꿀 수 있고, 이에 따른
        개인정보 처리방침의 지속적인 개선을 위해 필요한 절차를 정하고 있습니다.
      </p>
      <p className="f13 c_gray mt10">
        회사는 관련 법령에 의거한 개인정보 취급방침을 정하여 회원 권익 보호에
        최선을 다하고 있으며, 개인정보 처리방침을 개정하거나 변경할 때에는 APP내
        공지사항에 해당 내용을 알리고 있습니다.
      </p>
      <dl
        className={classNames(
          'f13',
          'c_gray',
          'mt20',
          'list_desc',
          'termsCont',
        )}
      >
        <dt className="relative pd_l20">
          <span className="desc">
            <strong>1.</strong>
          </span>
          <p>
            <strong>개인정보 수집에 대한 동의</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            중고나라는 회원의 개인정보처리방침, 이용약관, 전자금융거래 이용약관
            내용에 동의 및 동의 거부에 대해 버튼을 클릭할 수 있는 절차를
            마련하고 있으며, [동의합니다.] 버튼을 클릭하면 개인정보 수집에
            동의한 것으로 보고 관련 내용도 제공합니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>2.</strong>
          </span>
          <p>
            <strong>개인정보 수집 및 이용 목적</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            중고나라가 회원의 개인정보를 수집 및 이용하는 목적은 다음과
            같습니다.
          </p>
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w30'}>
                  <p>구분</p>
                </th>
                <th className={'w70'}>
                  <p>이용 목적</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>회원관리</p>
                </td>
                <td>
                  <p>회원제 서비스 이용에 따른 회원식별</p>
                  <p>불량회원의 부정이용 방지와 중복가입방지</p>
                  <p>가입의사 확인</p>
                  <p>미성년자의 확인</p>
                  <p>회원문의, 불만 접수 및 처리, 분쟁조정을 위한 기록보존</p>
                  <p>고지사항 전달</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    서비스 제공에 관한 계약의 이행 및 서비스 제공에 대한 수집
                  </p>
                </td>
                <td>
                  <p>회원간 거래 서비스 제공</p>
                  <p>콘텐츠 제공, 이벤트/경품당첨 결과안내 및 상품배송</p>
                  <p>금융거래 관련 본인인증 및 금융서비스</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>마케팅 및 광고에 활용( 이용동의 대상기준 )</p>
                </td>
                <td>
                  <p>최적화된 서비스 제공</p>
                  <p>새로운 상품 또는 서비스 안내</p>
                  <p>회원 관심사에 부합하는 서비스 및 이벤트 기획</p>
                  <p>서비스 및 상품 안내</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>3.</strong>
          </span>
          <p>
            <strong>수집하는 개인정보의 항목</strong>
          </p>
        </dt>
        <dd className="mt10">
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w25'}>
                  <p>유형</p>
                </th>
                <th className={'w25'}>
                  <p>구분</p>
                </th>
                <th className={'w25'}>
                  <p>수집/이용 항목</p>
                </th>
                <th className={'w25'}>
                  <p>수집/이용 목적</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={4}>
                  <p>필수(회원가입 및 부정이용방지 등 필수적인 정보)</p>
                </td>
                <td rowSpan={3}>
                  <p>회원공통</p>
                </td>
                <td>
                  <p>
                    이름, 생년월일, 아이디, 비밀번호, 휴대전화번호,
                    중복가입번호(DI), 연계정보(CI), 광고식별자(ADID/IDFA),
                    방문식별자(UUID), 말기 정보 (단말기 명, OS, 앱 버전),
                    법정대리인 정보(만 14세 미만 가입시에만 해당)
                  </p>
                </td>
                <td>
                  <p>
                    이용자 식별, 거래이행을 위한 연락, 서비스 이용에 따른 정보
                    제공(고지사항 전달, 본인의사 확인, 서비스관련상담, 민원사항
                    처리, 유의사항 등)
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    성명, 아이디(ID), 이메일(E-mail), 주소, 휴대전화번호,
                    서비스이용기록, 아이피 주소(IP address), 접속로그
                  </p>
                </td>
                <td>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    자동수집정보: 서비스이용기록, 이용정지기록, 이용해지 기록,
                    아이피 주소(IP address), 접속로그, 쿠키(cookie)
                  </p>
                </td>
                <td>
                  <p>
                    불법/부정이용 방지, 개인정보 유효기간제 준수, 최근 본 상품
                    등 서비스
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>사업자회원</p>
                </td>
                <td>
                  <p>
                    대표자명, 담당자명, 사업자등록번호,사업자 및 담당자 연락처,
                    법인등록번호, 은행계좌정보(예금주, 계좌번호), 인감증명서,
                    본인사실확인증명서, 이름, 주소, 연락처
                  </p>
                </td>
                <td>
                  <p>
                    판매자 회원가입 승인, 사업자 회원 서비스 제공, 중복가입
                    방지, 출고지/반품/교환지 주소 관리, 정산대금 수령을 위한
                    계좌정보 관리 등
                  </p>
                </td>
              </tr>
              <tr>
                <td rowSpan={4}>
                  <p>필수(회원간 거래 등 서비스 이용 시 필수적인 정보)</p>
                </td>
                <td rowSpan={4}>
                  <p>회원공통</p>
                </td>
                <td>
                  <p>이름, 수령인, 연락처, 배송지주소, 사진</p>
                </td>
                <td>
                  <p>
                    상품 및 경품 배송(반품/환불), 배송지 및 연락처 확인,
                    상품등록, 서비스관련상담, 민원사항 처리, 최초 입력 후
                    불러오기 기능 제공
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>계좌주명, 계좌번호</p>
                </td>
                <td>
                  <p>
                    대금결제 서비스, 구매취소 , 서비스관련상담, 민원사항 처리
                    등에 따른 거래금액 환불, 전자금융기록 보관
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    성명, 생년월일, 성별, 휴대전화번호(휴대폰 인증시),
                    CI(연계정보), DI(중복정보), IP, 위치정보
                  </p>
                </td>
                <td>
                  <p>
                    서비스 이용을 위한 이용자 식별, 최초본인인증 시 정보 자동
                    업데이트, 회원 연령확인, 거래 안전을 위해 본인인증 후
                    구매하거나 이용할 수 있는 서비스, 아이디(ID) 보유여부 확인,
                    거래안전 및 편법행위 방지
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>수취인 성명, 수취인 연락처, 수취인 주소</p>
                </td>
                <td>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td rowSpan={4}>
                  <p>선택</p>
                </td>
                <td>
                  <p>회원공통</p>
                </td>
                <td>
                  <p>전화번호, 이메일(E-mail), 주소, SMS, SNS</p>
                </td>
                <td>
                  <p>친구초대, 이벤트 및 알림정보 등 마케팅 활용</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>계좌등록 회원</p>
                </td>
                <td>
                  <p>계좌번호</p>
                </td>
                <td>
                  <p>거래대금 입금 및 환불처리</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>내차팔기 이용고객</p>
                </td>
                <td>
                  <p>
                    자동차등록번호, 말소등록일, 차명, 차종, 차대번호(뒤 6자리
                    제외), 원동기 형식, 용도, 연식, 색상, 출처구분, 최초등록일,
                    제작연월일, 검사유효기간 및 주행거리
                  </p>
                </td>
                <td>
                  <p>이용 내역 조회</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>파트너센터 이용고객</p>
                </td>
                <td>
                  <p>
                    성명, 생년월일, 성별, 휴대전화번호, CI(연계정보), 전화번호,
                    이메일(E-mail), 주소, 계좌주명, 계좌번호
                  </p>
                </td>
                <td>
                  <p>파트너센터의 판매/구매/배송/정산 진행</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>4.</strong>
          </span>
          <p>
            <strong>개인정보 수집방법</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            중고나라는 개인정보를 회원가입 절차, 서비스 이용 과정에서 회원이
            직접 입력한 정보를 수집하며 이동 전화 및 유, 무선 인터넷 서비스를
            사용할 때 생성정보 수집 도구를 통한 방법(쿠키) 등으로도 개인정보를
            수집합니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>5.</strong>
          </span>
          <p>
            <strong>개인정보 보유 및 이용기간</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 원칙적으로 회원의 개인정보를 회원탈퇴 시 지체 없이
            파기합니다. 다만, 회사 내부 방침에 따라 회원에게 미리 고지하고 동의
            받았거나 별도의 법령에서 정한 경우에는 그 기간동안 안전하게
            보관하며, 절대 다른 목적으로 이용하지 않습니다.
          </p>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>회사 내부 방침에 따라 보관하는 정보는 다음과 같습니다.</p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>비정상적인 회원탈퇴 등으로 인한 보관</p>
                  <p>보존 기간 : 회원탈퇴 신청 후 7일</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    임의탈퇴를 반복적으로 행하는 등 회사가 제공하는 등업신청,
                    이벤트 참여 등 비정상적 인 방법으로 이익을 편법적으로
                    이용하는 행위 차단
                  </p>
                  <p>보존 기간 : 회원탈퇴 신청 후 30일</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>부정 이용기록</p>
                  <p>보존 이유 : 부정 이용 방지</p>
                  <p>보존 기간 : 5년</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>사기예방을 위해 필요한 기록</p>
                  <p>보존 이유 : 사기 예방</p>
                  <p>보존 기간 : 3년</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>관련법령에 의한 정보보유 사유</p>
              <p>
                상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의
                규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한
                일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는
                정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>계약 또는 청약철회 등에 관한 기록</p>
                  <p>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간 : 5년</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>대금결제 및 재화 등의 공급에 관한 기록</p>
                  <p>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간 : 5년</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>소비자의 불만 또는 분쟁처리에 관한 기록</p>
                  <p>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간 : 3년</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>본인확인에 관한 기록</p>
                  <p>
                    보존 이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률
                  </p>
                  <p>보존 기간 : 6개월</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>방문에 관한 기록</p>
                  <p>보존 이유 : 통신비밀보호법</p>
                  <p>보존 기간 : 3개월</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>내차팔기 비교견적에 관한 기록</p>
                  <p>
                    보존 이유 : 자동차관리법 온라인자동차매매정보제공업 등에
                    관한 법률
                  </p>
                  <p>보존 기간 : 3년</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                1년 이상 서비스 이용 기록이 없는 회원의 정보는 ‘정보통신망
                이용촉진 및 정보보호 등에 관한 법률’의 ‘개인정보 유효기간제’
                적용에 따라 휴면계정으로 전환됩니다. 장기간(1년 이상) 서비스
                미이용자의 경우 개인정보보호를 위하여 별도로 DB에 분리하여 저장,
                관리되며 이후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에
                따라 일정 기간 저장된 후 파기되어 집니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">④</span>
              <p>
                휴면계정 전환 최소 30일 전, 등록된 전화번호 혹은 이메일 통해
                전환 예정 일자를 안내하고 전환을 원하지 않는 경우, 안내 확인 후
                로그인 하면 정상 서비스 이용 가능합니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>6.</strong>
          </span>
          <p>
            <strong>개인정보수집항목 중 제3자 제공에 대한 설명</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 회원들의 개인정보를 「2.수집한 개인정보의 수집 및 이용
            목적」에서 고지한 범위내에서 사용하며, 회원의 사전 동의 없이
            동범위를 초과하여 이용하거나 원칙적으로 회원의 개인정보를 제3자에게
            제공하지 않습니다. 다만, 개인정보 보호법 제17조에 해당하는 경우에는
            예외로 합니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>7.</strong>
          </span>
          <p>
            <strong>회원의 개인정보 열람 및 정정</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회원 및 법정대리인은 개인정보 보호법 제35조 및 제36조에 의해
                언제든지 등록되어 있는 자신 또는 대리자의 개인정보를 조회하거나
                수정할 수 있으며, 회사의 개인정보 처리에 동의하지 않는 경우
                동의를 거부하거나 가입 해지를 요청할 수 있습니다. 다만,
                개인정보의 처리에 대한 동의를 철회하시는 경우 부득이하게
                서비스의 일부 또는 전부의 이용이 제한될 수 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                개인정보 수정 및 가입 해지(동의 철회)는 아래와 같은 방법으로
                이용하실 수 있습니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>
                    개인정보 수정 : 로그인 후, ‘마이페이지 &gt; 내 프로필 홈으로
                    가기 &gt; 개인 정보 설정을 통해 수정하실 수 있습니다.
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    가입 해지(동의 철회) : 로그인 후, ‘마이페이지 &gt; 회원정보
                    수정 &gt; 회원 탈퇴하기’를 통해 탈퇴 주의사항을 확인 후 직접
                    탈퇴하실 수 있습니다.
                  </p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                회원이 개인정보의 오류에 대한 정정을 요구하신 경우에는 정정을
                완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
                또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
                하겠습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">④</span>
              <p>
                회사는 회원의 요청에 의해 해지 또는 삭제된 개인정보는 회사가
                수집하는 “개인정보의 보유 및 이용기간”에 명시된 바에 따라
                처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
                있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>8.</strong>
          </span>
          <p>
            <strong>개인정보 파기 절차 및 방법</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가
                불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나
                처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를
                계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의
                데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>
                    파기절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고,
                    회사의 개인정보 보호책임자의 승인을 받아 개인정보를
                    파기합니다.
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    파기방법 : 회사는 전자적 파일 형태로 기록․저장된 개인정보는
                    기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된
                    개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>9.</strong>
          </span>
          <p>
            <strong>아동의 개인정보보호를 위한 법정대리인 인증</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            중고나라는 만 14세 미만의 아동이 가입할 경우 법정대리인의 추가
            인증을 마련하고 있으며 추가 인증절차가 정상적으로 진행되어야
            회원가입을 진행하고 있습니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>10.</strong>
          </span>
          <p>
            <strong>개인정보 처리 업무위탁</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 기본적인 서비스, 더 나은 서비스 제공 및 회원편의 등 원활한
            업무 수행을 위해 다음과 같이 개인정보 처리 업무를 외부전문업체에
            위탁하여 운영하고 있습니다.
          </p>
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w20'}>
                  <p>수탁자</p>
                </th>
                <th className={'w40'}>
                  <p>위탁 목적</p>
                </th>
                <th className={'w40'}>
                  <p>보유 및 이용기간</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>㈜다우기술</p>
                </td>
                <td>
                  <p>신용카드 결제서비스 제공</p>
                </td>
                <td>
                  <p>
                    본인확인 기관에서 이미 보유한 개인정보 이므로 저장하지 않음
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜엔에이치엔페이코</p>
                </td>
                <td rowSpan={3}>
                  <p>즉시송금, 간편결제 서비스제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>주식회사 카카오페이</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜비바리퍼블리카</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>(주)SK telecom</p>
                </td>
                <td>
                  <p>T 전화 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>(주)SK 브로드밴드</p>
                </td>
                <td>
                  <p>안심번호 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>(주)BGF post</p>
                </td>
                <td>
                  <p>택배 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>(주)CVS net</p>
                </td>
                <td>
                  <p>택배 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜KG모빌리언스</p>
                </td>
                <td>
                  <p>
                    회원관리 회원제 서비스 이용에 따른 본인확인 (휴대전화 인증)
                  </p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>샌드버드코리아</p>
                </td>
                <td>
                  <p>거래서비스를 위한 채팅서비스제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>JB우리캐피탈</p>
                </td>
                <td>
                  <p>할부 및 담보대출 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜바름정비</p>
                </td>
                <td>
                  <p>정비예약 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜짐브러스</p>
                </td>
                <td>
                  <p>정비예약 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜다이어트카</p>
                </td>
                <td>
                  <p>리스, 렌트 승계 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>㈜엔에이치앤고도</p>
                </td>
                <td>
                  <p>파트너센터 서비스 제공</p>
                </td>
                <td>
                  <p>회원 탈퇴 및 위탁 계약 만료까지</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>11.</strong>
          </span>
          <p>
            <strong>고지 또는 통지방법 </strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 회원이 개인정보를 보호하기 위해 기술적 대책과 관리적
                대책을 마련하고 있으며, 이를 적용하고 있습니다. 개인정보처리방침
                등을 통하여 그 사실을 회원에게 고지하고 알리고 동의를 얻습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                회사가 과실없이 회원의 연락처를 알지 못하거나 천재지변 등 통지할
                수 없는 정당한 이유가 있으면 2곳 이상의 중앙일간지(회원의
                대부분이 특정 지역에 거주할 때에는 그 지역을 보급구역으로 하는
                일간지로 할 수 있습니다)에 1회 이상 공고하는 것으로 대신합니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>12.</strong>
          </span>
          <p>
            <strong>개인정보를 위한 기술 및 관리적 대책</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사에서는 회원의 개인정보를 보호하기 위해 기술적 대책과 관리적
            대책을 마련하고 있으며, 이를 적용하고 있습니다.
          </p>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>기술적 대책</p>
              <p>
                회사는 회원의 개인정보를 처리할 때 개인정보가 분실, 도난, 유출,
                변조 또는 훼손되지 않도록 다음과 같은 기술적 대책을 마련하여
                개인정보의 안전성을 확보하고 있습니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>비밀번호 보호, 중요 파일 및 데이터 암호화 등 보안 조치</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>바이러스 침해 방지용 백신프로그램 이용</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    암호화 알고리즘을 통한 네트워크상 개인정보 정보 보안장치(SSL
                    또는 SET) 채택
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    해킹 등 외부침입 방지를 위하여 침입차단시스템, 취약점 분석
                    시스템 도입
                  </p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>관리적 대책</p>
              <p>
                회사는 회원의 개인정보에 대한 접근권한을 최소한의 인원으로
                제한하고 있으며 이에 해당하는 자는 다음과 같습니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    개인정보보호책임자와 담당자 등 개인정보보호업무를 수행하는
                    자
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>기타 업무상 개인정보의 처리가 불가피한 자</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>개인정보 교육 실시 및 접근권한 관리, 접근통제</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    업무 인수인계 보안 유지, 입·퇴사 후 개인정보 사고에 대한
                    책임 명확화
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>전산실, 자료 보관실 등 특별 보호구역 출입 통제</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    담당자에게 식별부호(ID)와 비밀번호(Password)를 부여 및
                    비밀번호 주기적 갱신
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>정보보호 서약서 징구</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도로
                    분리하여 보관
                  </p>
                </li>
              </ul>
              <p className="mt10">
                회사는 회원 개인의 실수나 기본적인 인터넷의 위험성 때문에
                일어나는 일들에 대해 책임을 지지 않습니다. 회원은 본인의
                개인정보를 보호하기 위해서 자신의 아이디(ID)와
                비밀번호(Password)를 적절하게 관리하고 그에 대한 책임을 져야
                합니다.
              </p>
              <p className="mt10">
                공동으로 사용하는 모바일 기기 혹은 PC에서 중고나라 APP 및
                중고나라 모바일웹(WEB)에 접속하여 로그인 한 상태에서 다른
                사이트로 이동할 경우에, 서비스 이용을 종료할 때에는 반드시
                로그아웃 처리 후 해당 홈페이지를 종료하시기 바랍니다. 그렇지
                않으면 해당 브라우저를 통해 아이디(ID), 비밀번호(Password) 등
                회원의 정보가 타인에게 쉽게 유출될 수 있습니다.
              </p>
              <p className="mt10">
                그 밖에 내부 관리자의 실수나 기술관리 상의 사고로 회원의
                개인정보가 상실, 유출, 변조, 훼손되면 회사는 즉각 회원님께 해당
                사실을 알리고 적절한 대책과 보상을 마련할 것입니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>13.</strong>
          </span>
          <p>
            <strong>링크(사이트)에 대한 안내</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사가 회원에게 다른 회사의 웹사이트 또는 자료에 대한 링크를
            제공하는 경우, 회사는 외부사이트 및 자료에 대한 아무런 통제권이
            없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대해 책임질 수
            없으며 보증할 수 없습니다. 회사가 포함하고 있는 링크를
            클릭(click)하여 타사이트(site)의 페이지로 옮겨 갈 경우 해당 사이트의
            개인정보보호정책은 회사와 무관하므로 새로 방문한 사이트의 정책을
            검토해 보시기 바랍니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>14.</strong>
          </span>
          <p>
            <strong>
              개인정보 자동수집장치의 설치 운영 및 그 거부에 대한사항
            </strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 회원의 정보를 수시로 저장하고 찾아내는 쿠키(cookie,
                접속정보파일)를 운용합니다. 쿠키란 웹사이트를 운영하는 서버가
                이용자의 브라우저 또는 앱에 보내는 아주 작은 텍스트 파일로써
                디바이스에 저장됩니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                이용자는 ‘쿠키’에 대한 선택권을 가지고 있습니다. 모바일 기기
                설정 또는 옵션에서 설정함으로써 쿠키를 허용하거나 쿠키의 저장을
                거부할 수 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수
                있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>15.</strong>
          </span>
          <p>
            <strong>이용자의 권리와 의무</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회원의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를
                예방해 주시기 바랍니다. 부정확한 정보 입력으로 말미암아 발생하는
                사고의 책임은 회원한테 있으며 타인의 정보를 무단으로 사용하는 등
                허위정보를 입력하면 회원자격이 상실될 수 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                회원은 개인정보를 보호받을 권리와 함께 자신을 스스로를 보호하고
                타인의 정보를 침해하지 않을 의무도 지니고 있습니다.
                비밀번호(Password)를 포함한 회원의 개인정보가 유출되지 않도록
                조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록
                유의해 주십시오. 만약 이 같은 책임을 다하지 못하고 타인의 정보를
                훼손할 때에는 『정보통신망 이용촉진 및 정보보호 등 에 관한
                법률』 등에 의해 처벌받을 수 있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>16.</strong>
          </span>
          <p>
            <strong>개인정보보호 책임자 및 담당자</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
                처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와
                같이 개인정보 보호책임자를 지정하고 있습니다.
              </p>
              <dl className="mt10">
                <dt>
                  <p>▶ 개인정보 보호책임자</p>
                </dt>
                <dd>
                  <p>성명 : 권오현</p>
                  <p>직위 : 이사</p>
                  <p>전화번호 : 070-5066-2278</p>
                  <p>팩스 : 070-8220-5331</p>
                  <p>전자우편 : joongna@qdillion.com</p>
                </dd>
              </dl>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                정보주체를 회사의 서비스(또는 사업)을 이용아시면서 발생한 모든
                개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
                개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는
                정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인
                개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다
                자세한 도움이 필요하시면 문의하여 주시기 바랍니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>개인정보분쟁조정위원회 : www.kopico.go.kr / 1833-6972</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>개인정보침해신고센터 : privacy.kisa.or.kr / 118</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>대검찰청 첨단범죄수사센터 : www.spo.go.kr/ 02-3480-2000</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>경찰청 사이버안전국 : cyberbureau.police.go.kr / 182)</p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>17.</strong>
          </span>
          <p>
            <strong>고지의 의무</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            현 개인정보처리방침은 2019년 08월 29일에 제정되었으며
            개인정보처리방침 내용이 변경되는 경우, 중고나라 APP의 ‘공지사항’란을
            통해 알릴 것입니다.
          </p>
        </dd>
      </dl>
    </article>
  );
};

export default PrivacyPolicy_v5;
